import * as React from "react";
import {
  Block,
  Page,
  Navbar,
  NavTitle,
  BlockTitle,
  Card,
  Col,
  Row,
  Link,
  Icon,
} from "framework7-react";
import { CONSTRUCTION } from "src/utils/utils";

export default class HomePage extends React.Component {
  public render() {
    return (
      <Page>
        <Navbar>
          {/* <NavLeft leftBreakpoint={800}>
            <Link panelOpen="left">
              <i className="icon icon-menu" />
            </Link>
          </NavLeft> */}
          <NavTitle>
            <div>
              <div className="logo-light">
                <img src="img/logo-light.png" alt="Logo Crypto Loots" />
              </div>
              <div className="menu-items">
                <div className="item-menu">
                  <img src="https://img.icons8.com/material-two-tone/48/null/big-parcel.png" />
                  <span>UNBOXING</span>
                </div>

                <div className="item-menu">
                  <img src="https://img.icons8.com/material-two-tone/48/null/user-shield.png" />
                  <span>BATTLES</span>
                </div>

                <div className="item-menu">
                  <img src="https://img.icons8.com/material-two-tone/48/null/gift.png" />
                  <span>FREE DROP</span>
                </div>

                <div className="item-menu">
                  <img src="https://img.icons8.com/material-two-tone/48/null/info--v2.png" />
                  <span>HOW IT WORKS</span>
                </div>
              </div>
            </div>
          </NavTitle>
          {/* <NavRight>
            <Link iconIos="f7:menu" iconMd="material:menu" panelOpen="right" />
          </NavRight> */}
        </Navbar>
        <BlockTitle className="block-title-large">
          FEATURED BOXES
          <Link className="viewAllLink" onClick={() => CONSTRUCTION(this)}>
            View All Boxes
            <Icon icon="icon icon-chevrons-right" />
          </Link>
        </BlockTitle>

        <Block>
          <Row resizable={true}>
            <Col className={"medium-50"}>
              <Card
                outline={true}
                title="BOX 1"
                content="lorem"
                footer="lorem"
              />
            </Col>
            <Col className={"medium-50"}>
              <Card
                outline={true}
                title="BOX 2"
                content="lorem"
                footer="lorem"
              />
            </Col>
            <Col className={"medium-50"}>
              <Card
                outline={true}
                title="BOX 3"
                content="lorem"
                footer="lorem"
              />
            </Col>
            <Col className={"medium-50"}>
              <Card
                outline={true}
                title="BOX 4"
                content="lorem"
                footer="lorem"
              />
            </Col>
          </Row>

          <Row resizable={true}>
            <Col className={"medium-50"}>
              <Card
                outline={true}
                title="BOX 5"
                content="lorem"
                footer="lorem"
              />
            </Col>
            <Col className={"medium-50"}>
              <Card
                outline={true}
                title="BOX 6"
                content="lorem"
                footer="lorem"
              />
            </Col>
            <Col className={"medium-50"}>
              <Card
                outline={true}
                title="BOX 7"
                content="lorem"
                footer="lorem"
              />
            </Col>
            <Col className={"medium-50"}>
              <Card
                outline={true}
                title="BOX 8"
                content="lorem"
                footer="lorem"
              />
            </Col>
          </Row>
        </Block>

        <BlockTitle className="block-title-large">
          LATEST BATTLES
          <Link className="viewAllLink" onClick={() => CONSTRUCTION(this)}>
            View All Battles
            <Icon icon="icon icon-chevrons-right" />
          </Link>
        </BlockTitle>

        <Block>
          <Row resizable={true}>
            <Col width="100">
              <Card outline={true} title="Battle 1" content="lorem" />
            </Col>
            <Col width="100">
              <Card outline={true} title="Battle 2" content="lorem" />
            </Col>
            <Col width="100">
              <Card outline={true} title="Battle 3" content="lorem" />
            </Col>
            <Col width="100">
              <Card outline={true} title="Battle 4" content="lorem" />
            </Col>
          </Row>
        </Block>

        <Block>
          <br />
          <BlockTitle className="block-title-large">FOOTER</BlockTitle>
          <br />
        </Block>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/HomePage.tsx